import { Box, Link as MuiLink, SvgIcon, alpha, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'

import { getSocialLinkIcon } from '~/features/chatbot/components/socialLinks/utils'
import { EChatbotTheme, TLink } from '~/features/settings/models'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  links: TLink[]
}

function SocialLinks({ links }: TProps) {
  const theme = useTheme()
  const chatbotLayout = store((state) => state.chatbot.layout)
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        justifyContent:
          chatbotLayout.selection.theme === EChatbotTheme.linkView
            ? 'center'
            : 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {links.map((link) => {
        const socialIcon = getSocialLinkIcon(link.url)
        return (
          socialIcon && (
            <MuiLink
              component={Link}
              key={link.url}
              to={link.url}
              target="_blank"
            >
              <SvgIcon
                sx={{
                  fontSize: { xxxs: 27, md: 32 },
                  color: theme.palette.common.white,
                  backgroundColor:
                    chatbotLayout.selection.theme === EChatbotTheme.linkView
                      ? chatbotLayout.options[EChatbotTheme.linkView][
                          chatbotLayout.selection[EChatbotTheme.linkView]
                        ].mainBackgroundColor
                      : theme.palette.secondary1,
                  borderRadius: '50%',
                  border:
                    chatbotLayout.selection.theme === EChatbotTheme.linkView
                      ? 'none'
                      : `${rem(2)} solid ${chatbotLayout.selection[EChatbotTheme.simple]}`,

                  padding: rem(3),
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.common.white, 0.2),
                    cursor: 'pointer',
                    transform: 'scale(1.1)',
                  },
                  transition: 'all 0.3s ease-in-out',
                }}
              >
                {socialIcon}
              </SvgIcon>
            </MuiLink>
          )
        )
      })}
    </Box>
  )
}

export default SocialLinks
